export default __webpack_public_path__ + "static/media/about_us.5a3e7fa6.jpg";